import * as PIXI from 'pixi.js';
import { GameEngine } from './server/GameEngine';

export class CascadeCounter extends PIXI.Container {
    private bonusCounter: PIXI.Text;
    private win: number = 0;
    private multiplier: number = 0;

    constructor() {
        super(); // Call the PIXI.Container constructor

        // Initialize the PIXI.Text object
        this.bonusCounter = new PIXI.Text({
            text: '7',
            style: {
                fontSize: 60,
                fontFamily: "TextFont",
                fill: "0xffcc00",
                fontWeight: "bold",
                stroke: {
                    color: 0x000000,
                    width: 4,
                }
            }
        });
        this.bonusCounter.anchor.set(0.5);

        // Add the bonusCounter as a child of this container
        this.addChild(this.bonusCounter);
    }

    // Method to set the initial amount of freespins
    public setWin(amount: number): void {
        this.win = amount;
        this.updateText();
    }

    // Method to add to the multiplier (accumulates the value)
    public addMultiplier(amount: number): void {
        this.multiplier += amount; // Multiply the current multiplier by the given amount
        this.updateText();
    }

    // Method to reset the multiplier to the default value
    public resetMultiplier(): void {
        this.multiplier = 0; // Reset to 1 (or another appropriate default value)
        this.updateText();
    }

    // Method to update the text of the bonusCounter
    private updateText(): void {
        if (this.multiplier > 0) {
            this.bonusCounter.text = `${GameEngine.getInstance().getFormatter().format(this.win)} x${this.multiplier}`;
        } else {
            this.bonusCounter.text = `${GameEngine.getInstance().getFormatter().format(this.win)}`;
        }
    }

}
